import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';

const TeamBattingChart = ({ leaderboards }) => {
  const { hrData, avgData, rbiData } = useMemo(() => {
    const leaders = leaderboards?.batting?.leagueLeaders || [];

    const getLeaders = (cat) => {
      const found = leaders.find(
        (l) =>
          l.leaderCategory === cat ||
          l.leaderCategory?.toLowerCase() === cat.toLowerCase()
      );
      return found?.leaders?.slice(0, 8) || [];
    };

    const hrLeaders = getLeaders('homeRuns');
    const avgLeaders = getLeaders('battingAverage');
    const rbiLeaders = getLeaders('runsBattedIn');

    return {
      hrData: {
        names: hrLeaders.map((l) => l.person?.fullName?.split(' ').pop() || '--'),
        vals: hrLeaders.map((l) => Number(l.value) || 0),
      },
      avgData: {
        names: avgLeaders.map((l) => l.person?.fullName?.split(' ').pop() || '--'),
        vals: avgLeaders.map((l) => Number(l.value) || 0),
      },
      rbiData: {
        names: rbiLeaders.map((l) => l.person?.fullName?.split(' ').pop() || '--'),
        vals: rbiLeaders.map((l) => Number(l.value) || 0),
      },
    };
  }, [leaderboards]);

  const makeOption = (data, color, name) => ({
    backgroundColor: 'transparent',
    grid: { top: 20, right: 16, bottom: 60, left: 44 },
    tooltip: {
      trigger: 'axis',
      backgroundColor: '#1e3a29',
      borderColor: '#658d71',
      textStyle: { color: '#d8ceb3', fontSize: 10 },
    },
    xAxis: {
      type: 'category',
      data: data.names,
      axisLabel: { color: '#a9c9b1', fontSize: 8, rotate: 30 },
      axisLine: { lineStyle: { color: '#658d71' } },
    },
    yAxis: {
      type: 'value',
      minInterval: 1,
      axisLabel: { color: '#a9c9b1', fontSize: 9 },
      axisLine: { lineStyle: { color: '#658d71' } },
      splitLine: { lineStyle: { color: 'rgba(101,141,113,0.2)' } },
    },
    series: [
      {
        name,
        type: 'bar',
        data: data.vals,
        itemStyle: { color: color + 'CC', borderColor: color, borderWidth: 1 },
      },
    ],
  });

  if (!hrData.names.length) return (
    <div className="text-[#658d71] text-xs text-center py-8 uppercase tracking-widest">
      No batting data available
    </div>
  );

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-3">
      {[
        { data: hrData, color: '#c4333e', name: 'Home Runs', label: 'Home Runs' },
        { data: avgData, color: '#d8ceb3', name: 'Batting Avg', label: 'Batting Average' },
        { data: rbiData, color: '#a9c9b1', name: 'RBI', label: 'RBI' },
      ].map(({ data, color, name, label }) => (
        <div key={name} className="border border-[#658d71] bg-[rgba(0,0,0,0.08)]">
          <div className="px-3 py-2 border-b border-[#658d71] bg-[rgba(0,0,0,0.1)]">
            <span className="text-xs font-black uppercase tracking-widest text-[#d8ceb3]">
              {label}
            </span>
            {data.names.length === 0 && (
              <span className="ml-2 text-[9px] text-[#658d71] uppercase tracking-widest">
                (no data)
              </span>
            )}
          </div>
          <div className="p-2">
            {data.names.length > 0 ? (
              <ReactECharts option={makeOption(data, color, name)} style={{ height: '160px' }} />
            ) : (
              <div className="flex items-center justify-center h-[160px] text-[#658d71] text-[10px] uppercase tracking-widest">
                No {label} data
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TeamBattingChart;